// In your Javascript (external .js resource or <script> tag)
$(document).ready(function() {
    $('.select').select2();
});


$('#select-country').change(function () {
    var optionSelected = $('#select-country').find('option:selected');
    if (optionSelected.attr('value')) {
        location.href = optionSelected.attr('data-home');
    }
});